import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Map } from "immutable";

export const modifiedAt = time =>
  time ? moment(time).format("MMM D YYYY, h:mm:ss a") : "Unknown";

export const modifiedBy = name => name || "System";

const createdBy = record => (
  <span>
    Created: {modifiedAt(record.getIn(["created_at"]))} by{" "}
    {modifiedBy(record.getIn(["created_by", "full_name"]))}
  </span>
);

const updatedBy = record => (
  <span>
    Last Edited: {modifiedAt(record.getIn(["updated_at"]))} by{" "}
    {modifiedBy(record.getIn(["updated_by", "full_name"]))}
  </span>
);

const divider = multiLine =>
  multiLine ? (
    <br />
  ) : (
    <span>
      &nbsp;
      <i className="fa fa-long-arrow-right" />
      &nbsp;
    </span>
  );

const AuditFields = ({ record, multiLine }) => {
  const showUpdatedBy =
    record.getIn(["updated_at"]) !== record.getIn(["created_at"]);

  return (
    <p className="text-muted small">
      <em>
        {createdBy(record)}
        {showUpdatedBy && divider(multiLine)}
        {showUpdatedBy && updatedBy(record)}
      </em>
    </p>
  );
};

AuditFields.propTypes = {
  record: PropTypes.instanceOf(Map),
  multiLine: PropTypes.bool
};

export default AuditFields;



// WEBPACK FOOTER //
// ./app/modules/shared/components/AuditFields/AuditFields.jsx